import React, { useContext, useEffect } from "react";
import { Route } from "react-router-dom";
import { PostApi999 } from "../modules/network/padoPost";
import { openLayerFn } from "../views/Layout";
import { AppContext } from "./AppProvider";
const CustomRoute = props => {
  const { phonecfg, cfg, userinfo, auth, dispatch } = useContext(AppContext);

  useEffect(() => {
    if (!auth) {
      openLayerFn($(".alert-layer-logout"));
    } else {
      PostApi999(phonecfg, cfg, userinfo.userToken)
        .then(res => {
          if (res.resultMsg === "SUCCESS") {
            if (res.resultList != 1) {
              openLayerFn($(".alert-layer-logout"));
              // dispatch({ type: LOG_OUT_SUCCESS });
              // socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {"login":"out", "userToken":""});
            }
          }
        })
        .catch(err => {});
    }
  }, []);

  return auth ? (
    <Route
      path={props.path}
      exact={!!props.exact}
      component={props.component}
    />
  ) : (
    // <Redirect to="/membership/login" />
    <Route
      path={props.path}
      exact={!!props.exact}
      component={props.component}
    />
  );
};

export default CustomRoute;
